import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AssessmentTemplate } from "../../../model/assessment";
import { ASSESSMENT_TEMPLATE_STATE } from "../../../shared/enums";

const initialState: {
  templates: Array<AssessmentTemplate>;
  state: ASSESSMENT_TEMPLATE_STATE;
  pending: boolean;
  error: { value: boolean; message?: string; code?: string };
} = {
  templates: [],
  state: ASSESSMENT_TEMPLATE_STATE.fetching,
  pending: false,
  error: { value: false, message: "" },
};

export const assessmentTemplateStore = createSlice({
  name: "assessment-template-store",
  initialState,
  reducers: {
    setTemplates(state, action: PayloadAction<Array<AssessmentTemplate>>) {
      return {
        ...state,
        templates: action.payload,
      };
    },
    templatesFetchStart(state) {
      return {
        ...state,
        pending: true,
        state: ASSESSMENT_TEMPLATE_STATE.fetching,
      };
    },
    templatesFetchSuccess(
      state,
      action: PayloadAction<Array<AssessmentTemplate>>
    ) {
      return {
        ...state,
        templates: action.payload,
        pending: false,
        state: ASSESSMENT_TEMPLATE_STATE.fetchSuccess,
      };
    },
  },
});

export const { setTemplates, templatesFetchStart, templatesFetchSuccess } =
  assessmentTemplateStore.actions;
